import React from 'react';

import { TCard } from '@/services/requests/Recommendation/types/template8';

import TableDesktop from './TableDesktop';
import TableMobile from './TableMobile';

export type TProps = {
  template: string;
  column_header: {
    title: string;
    description?: string;
  }[];
  cards: TCard[];
};

export default function Table({ template, column_header, cards }: TProps) {
  const prefixTemplateClass = `vitrine-template${template}`;

  return (
    <div className={`${prefixTemplateClass}__table-wrap`}>
      <TableDesktop
        template={template}
        column_header={column_header}
        cards={cards}
      />
      <TableMobile template={template} cards={cards} />
    </div>
  );
}
